import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    messageTemplateDeleteRequest,
    searchEntityRequest,
    clearRedux,
} from 'Redux/actions';

const DeleteMessageTemplate = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const {
        openModal,
        loading,
        messageTemplate,
        result,
    } = useSelector(state => state.deleteMessageTemplateRedux);

    const handleDelete = () => {
        dispatch(messageTemplateDeleteRequest(messageTemplate?.id))
    }

    const closeModal = () => {
        dispatch(clearRedux("MESSAGE_TEMPLATE_DELETE"))
    }

    useEffect(() => {
        if (result) {
            if (result?.delete) {
                NotificationManager.success(
                    messages['message_template_delete_success_message'],
                    messages['message_template_delete_title'],
                    3000
                );
                tableRef && tableRef?.current?.getData();
                closeModal()
                dispatch(clearRedux("MESSAGE_TEMPLATE_DELETE", { result: null }))
            } else {
                let message = messages['message_template_delete_general_error']
                if (result && result?.error && result?.error?.includes("in use")) {
                    if (result?.error?.includes("Unit")) {
                        message = messages['message_template_delete_package_in_use_unit']
                    }
                    if (result?.error?.includes("DeviceModel")) {
                        message = messages['message_template_delete_package_in_use_device_model']
                    }
                    if (result?.error?.includes("UnitType")) {
                        message = messages['message_template_delete_package_in_use_unit_type']
                    }
                }

                NotificationManager.error(
                    message,
                    messages['message_template_delete_title'],
                    3000,
                );
                dispatch(clearRedux("MESSAGE_TEMPLATE_DELETE", { result: null }))
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={`${messages['message_template_delete_title']} (${messageTemplate?.templateCode} - ${messageTemplate?.language})`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    {messages['message_template_delete_message']}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={handleDelete}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteMessageTemplate;


